import type { MCPSharing } from "../../services/agent-tools-service";
import type { OrgUser } from "./hooks/useUsers";
import { requiresFullMcpAccess } from "./organizationAccess";

// BAD-1327 is scoped to per-user MCP permissions. Organization and project
// sharing keep their existing behaviour except the organization Viewer denial,
// while user-scoped connections only
// expose mutating actions to editors/owners. Legacy string recipients are
// viewers by definition.
export const isMcpOrganizationViewer = (user: OrgUser | undefined): boolean =>
  user?.organizationRole?.trim().toLowerCase() === "viewer";

export const canManageMcpConnection = (
  sharing: MCPSharing | null | undefined,
  currentUser: OrgUser | undefined,
): boolean => {
  // Organization Viewers cannot write, regardless of a connection grant.
  if (isMcpOrganizationViewer(currentUser)) return false;
  if (requiresFullMcpAccess(currentUser)) return true;
  if (!sharing) return false;
  if (sharing.scope !== "user") return true;
  if (!currentUser) return false;

  const recipient = sharing.items.find((item) =>
    typeof item === "string"
      ? item === currentUser.id
      : item.id === currentUser.id,
  );

  if (!recipient || typeof recipient === "string") return false;
  return recipient.role === "editor" || recipient.role === "owner";
};
